import { __rest, __assign } from '../../node_modules/tslib/tslib.es6.js';
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classNames from '../../node_modules/classnames/index.js';

var CButtonToolbar = forwardRef(function (_a, ref) {
    var children = _a.children, className = _a.className, rest = __rest(_a, ["children", "className"]);
    return (React.createElement("div", __assign({ className: classNames('btn-toolbar', className) }, rest, { ref: ref }), children));
});
CButtonToolbar.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
};
CButtonToolbar.displayName = 'CButtonToolbar';

export { CButtonToolbar };
//# sourceMappingURL=CButtonToolbar.js.map
